import { environment } from "src/environments/environment";

export const facebookURL = environment.facebookUrl;

export const googleURL = environment.googleUrl;

/**
 * API Base URL
 */
export const baseURL = environment.baseUrl;
